import { cn } from '../../lib/cn';

const variants = {
  primary:   'bg-[var(--accent)] text-white hover:bg-[var(--accent-hover)] active:scale-[0.98] shadow-sm',
  secondary: 'bg-[var(--bg-muted)] text-[var(--text-primary)] hover:bg-[var(--bg-hover)] border border-[var(--border)]',
  ghost:     'bg-transparent text-[var(--text-secondary)] hover:bg-[var(--bg-hover)] hover:text-[var(--text-primary)]',
  danger:    'bg-[var(--danger)] text-white hover:opacity-90 active:scale-[0.98]',
  outline:   'bg-transparent border border-[var(--accent)] text-[var(--accent)] hover:bg-[var(--accent-muted)]',
  success:   'bg-[var(--success)] text-white hover:opacity-90',
};
const sizes = {
  xs:   'h-7  px-3   text-xs  rounded-lg   gap-1.5',
  sm:   'h-8  px-3.5 text-[13px] rounded-[10px] gap-2',
  md:   'h-10 px-4   text-[14px] rounded-[10px] gap-2',
  lg:   'h-11 px-5   text-[15px] rounded-xl  gap-2.5',
  icon: 'h-9  w-9    rounded-[10px] flex items-center justify-center',
};

export function Button({ variant='primary', size='md', className, disabled, loading, children, ...props }) {
  return (
    <button
      className={cn('inline-flex items-center justify-center font-semibold transition-all duration-150 select-none whitespace-nowrap cursor-pointer disabled:opacity-40 disabled:pointer-events-none', variants[variant], sizes[size], className)}
      disabled={disabled || loading}
      {...props}
    >
      {loading && <span className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />}
      {children}
    </button>
  );
}
